import { useMemo } from 'react';
import { AnyVariables } from 'urql';

import { UseOptionQueryParams } from '@/components/FilterNew/types';
import usePagination from '@/hooks/usePagination';

import { getEntityFilterGroups } from '../../utils';

function useFilterOptionsQuery<
  Query extends object,
  T extends string,
  Variables extends AnyVariables = AnyVariables,
>({ useQuery, edgeKey, variables, getFilterOption }: UseOptionQueryParams<Query, T, Variables>) {
  const { isLoading, error, fetchMore, data, isFetchingMore } = usePagination(useQuery, variables, {
    edgeKey,
  });

  const groups = useMemo(
    () => getEntityFilterGroups(data, getFilterOption),
    [data, getFilterOption],
  );

  return {
    groups,
    error,
    fetching: isLoading || isFetchingMore,
    fetchMore,
  };
}

export default useFilterOptionsQuery;
